import React from 'react'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import Layout from '../components/Layout'
import CTA from '../components/CallToActionForm'
import styles from './course.module.css'
import CourseOffer from '../components/CourseOffer'
import { Container, Segment, Divider, Image, Card, Header, Icon, Transition } from 'semantic-ui-react'
import ReactDOM from 'react-dom'
import Comments from '../components/Comments'
import SocialMediaTag from '../components/SocialMediaTag'
import StructureData from '../components/StructureData'
import { Article, Breadcrumb } from '../components/StructureData'
import { bannerPath, toSlug, slash } from '../utils/utils'
import _ from 'lodash';

const HeaderCard = ({title, meta, description}) => {
  const mainTitle = _.capitalize(title) + ' Course Overview';
  return <div className={styles.description}>
    <Image src={bannerPath(title)} size='massive' alt={mainTitle}/>
    <Header as='h1'>{mainTitle}</Header>
    <Divider />
    <div>{description}</div>
  </div>
}

class Course extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 1,
      active: true,
      tooltip: true
    }
  }

  handleClick = (index) => {
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index
    this.setState({ activeIndex: newIndex })
  }

  componentDidMount() {

    const _this = this;

    ReactDOM.findDOMNode(this.props.top).scrollIntoView();

    setTimeout(() => {
      _this.setState((state, props) => {
        state.active = false;
      });

    }, 500);

    setTimeout(() => {
      _this.setState((state, props) => {
        state.tooltip = false;
      })
    }, 2500);

    if(typeof FB !== "undefined") {
      FB.XFBML.parse();
    }
  }


  render() {

    const pathWithDomain = (uri) => {
      return `${process.env.URL}${uri}`
    }

     const { activeIndex, active, tooltip } = this.state;
     const path = this.props.location.pathname;
     const {
        title,
        header1, description1,
        header2, description2,
        header3, description3,
        header4, description4,
        header5, description5,
        header6, description6,
        header7, description7,
        header8, description8,
        job, demand, salary, category
      } = this.props.pathContext.node.node;
      console.log(category);
      const sidebar = () => ( <CTA title={title} />)
      const description = `Not sure about outlook of ${title}? Finding the reason of study in ${title}?
      We provide you the propsect in ${category} industry/domain.
      You will find insightful data such as job demand, salary, pathway and more`;
      const pageTitle = `Major in ${title} | Uni Village Education`
      const article = Article("University Village", title,
        "UniVillage", process.env.URL,
        description, [`${pathWithDomain(bannerPath(title))}`]);

      const breadcrumbList = [{name: "Home", id: `${pathWithDomain('')}` },
        {name: "Course", id: `${pathWithDomain(slash(toSlug(title)))}` } ];

      const paragraph = (content) => {
        return content.split("\n").map((line, i) => {
          return <p key={i}>{line}</p>
        });
      }


      const section = (header, desc, i) => {
        if(header === '-') {
          return <div />
        }
        return <div className={styles.description}>
         <Header as='h2'>{header}</Header>
         {desc}
         <Divider hidden />
        </div>
      }

      const content = () => {
        return <div>
        <HeaderCard title={title} description={paragraph(description1.v)} />
        <Divider hidden />
        {header2 && section(header2, paragraph(description2.v), 2)}
        {header3 && section(header3, paragraph(description3.v), 3)}
        {header4 && section(header4, paragraph(description4.v), 4)}
        {header5 && section(header5, paragraph(description5.v), 5)}
        {header6 && section(header6, paragraph(description6.v), 6)}
        {header7 && section(header7, paragraph(description7.v), 7)}
        </div>
      }


      return (<div><Helmet>
              <title>{pageTitle}</title>
              <meta name="description" content={description} />
          </Helmet>
          <SocialMediaTag type="article"
            image={`${pathWithDomain(bannerPath(title))}`}
            title={title}
            url={path}
            description={description}
          />
          <StructureData meta={article} />
          <StructureData meta={Breadcrumb(breadcrumbList)} />
          <Layout Left={content} Right={sidebar}/>
          <Comments key={path} path={path} />
        </div>)

  }
}
export default Course;



// WEBPACK FOOTER //
// ./src/templates/major.js